"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPatientsRequest = fetchPatientsRequest;
const api_1 = require("../utils/api");
async function fetchPatientsRequest({ org, mod, internal }) {
    const url = internal ? "/patients/internal" : "/patients";
    const { data } = await api_1.api.get(`${url}?organization=${org}&module=${mod}`);
    return data;
}
